export default __webpack_public_path__ + "static/MediaContentSevenFancybox-a63373f387287182a388aab7ab17e007.webp";